import React from 'react';
import { useParams } from 'react-router-dom';
import { VideoNavigation, TechVideos, PluginVideos, OpportunitiesVideos } from '../components/Client/Videos';

const Videos = () => {
    const { id } = useParams();

    const renderVideoContent = () => {
        switch(id) {
            case 'tech':
                return <TechVideos />;
            case 'plugins':
                return <PluginVideos />;
            default:
                return <OpportunitiesVideos />;
        }
    };

    return (
        <section className="container mx-auto px-4">
            <div className="flex flex-col md:flex-row my-[80px]">
                {/* Navigation Column */}
                <div className="w-full md:w-1/4 lg:w-[320px] pt-4">
                    <VideoNavigation currentId={id} />
                </div>
                
                {/* Content Column */}
                <div className="w-full md:w-3/4 lg:flex-1 pt-4 md:pl-6">
                    {renderVideoContent()}
                </div>
            </div>
        </section>
    );
};

export default Videos;